import envConfig from "./envConfig";

export default {
  AUTH_LOGIN: `${envConfig.apiBackend!}/api/Auth/Login`,
  refreshTokenConfigs: {
    closeToTokenExpirationTime: 39600000,
    refreshTokenUrl: `${envConfig.apiBackend!}/api/Auth/RefreshToken`,
  },
};
